import React from 'react';
import Component from './Component';
import immutable from 'immutable';

export default class NumberIntervalFilter extends Component {

	static filterDelay = true;

	handleChange(e) {
		if (this.props.onChange) {
			this.props.onChange(this.getValue())
		}
	}

	handleBlur(e) {
		if (this.props.onBlur) {
			this.props.onBlur(this.getValue())
		}
	}

	getValue() {
		const v = e.target.value;
		const parts = v.split('-');
		const value = {
			from: null,
			to: null
		}
		if (parts.length == 1) {
			value.from = v;
			value.to = v;
		}
		else {
			value.from = parts[0].trim();
			value.to = parts[1].trim();
		}
		return immutable.Map(value);
	}

	render() {
		return (
			<input type="text"
					{...this.props}
				   className="form-control"
				   value={typeof this.props.value != 'undefined' && this.props.value != null ? this.props.value.toString() : ''}
				   onChange={(e) => this.handleChange(e)}
				   onBlur={(e) => this.handleBlur(e)}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/NumberIntervalFilter.js